module.exports = __webpack_public_path__ + "img/avatar_real_8.7f15ba57.jpg";